import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/workflows/{workflowId}']['GET'];

type Props = ThisApi['params'];

const getWorkflowById = async ({ id }: Props): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/workflows/${id}`);
  return response.data;
};

export default getWorkflowById;